import { render, staticRenderFns } from "./AdminTenant.vue?vue&type=template&id=179377c1"
import script from "./AdminTenant.vue?vue&type=script&lang=ts"
export * from "./AdminTenant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports